export const CHAT_STORAGE_KEYS = {
  session: 'sg-chatbot-session',
  messages: 'sg-chatbot-chat-messages',
  sessionId: 'sg-chatbot-session-id',
  authenticatedUserId: 'sg-chatbot-authenticated-user-id',
  lastCustomerId: 'sg-chatbot-last-customer-id',
  lastFleetId: 'sg-chatbot-last-fleet-id',
} as const;

export const getUserPreferenceStorageKeys = (authenticatedUserId: string) => {
  const encodedUserId = encodeURIComponent(authenticatedUserId);

  return {
    lastCustomerId: `${CHAT_STORAGE_KEYS.lastCustomerId}:${encodedUserId}`,
    lastFleetId: `${CHAT_STORAGE_KEYS.lastFleetId}:${encodedUserId}`,
  } as const;
};